import React from "react";
import ResourceHero from "../components/resources/ResourceHero";
import "../css/Photos.css";

export default function Photos() {
  const photos = [
    {
      image:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=900",
      title: "Annual Sports Day",
    },
    {
      image:
        "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=900",
      title: "Science Exhibition",
    },
    {
      image:
        "https://images.unsplash.com/photo-1513258496099-48168024aec0?w=900",
      title: "Art Competition",
    },
    {
      image:
        "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900",
      title: "Classroom Activities",
    },
    {
      image:
        "https://images.unsplash.com/photo-1529390079861-591de354faf5?w=900",
      title: "School Campus",
    },
    {
      image:
        "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=900",
      title: "Cultural Programme",
    },
    {
      image:
        "https://images.unsplash.com/photo-1588072432836-e10032774350?w=900",
      title: "Library Session",
    },
    {
      image:
        "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=900",
      title: "Morning Assembly",
    },
    {
      image:
        "https://images.unsplash.com/photo-1516534775068-ba3e7458af70?w=900",
      title: "Student Activities",
    },
  ];

  return (
    <>
      <ResourceHero
        title="Photo Gallery"
        subtitle="Explore memorable moments from Sahara Public Secondary School."
        image="/images/Education_Funds3.png"
      />

      <section className="photos-section">
        <div className="photos-heading">
          <h2>School Gallery</h2>

          <p>
            A glimpse of academics, sports, cultural events and student life at
            Sahara Public Secondary School.
          </p>
        </div>

        <div className="photos-grid">
          {photos.map((photo, index) => (
            <div className="photo-card" key={index}>
              <img src={photo.image} alt={photo.title} />

              <div className="photo-overlay">
                <h3>{photo.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
